// Remove Campaign Users
export const REMOVE_CAMPAIGN_USERS_REQUEST = 'REMOVE_CAMPAIGN_USERS_REQUEST';
export const REMOVE_CAMPAIGN_USERS_DONE = 'REMOVE_CAMPAIGN_USERS_DONE';
export const REMOVE_CAMPAIGN_USERS_FAILED = 'REMOVE_CAMPAIGN_USERS_FAILED';
